import NsField from "../../../../components/fields/NsField";
import {Tag} from "primereact/tag";
import {getStrRgba, getTextColorForBackgroundStrRgba} from "../../../../utility/common";
import NsButton from "../../../../components/buttons/NsButton";
import React from "react";

export default function FiltroRicercaKpiView({
                                                 statiKpi,
                                                 translate,
                                                 filtroKpi,
                                                 updateFiltroKpi,
                                                 onClickCerca,
                                                 onClickAzzeraFiltri,
                                             }) {

    return (
        <div className={'ns-overflow-auto ns-overflow-tree'}>
            <div className={'col-md-12 pt-1'}>
                <NsField
                    id="codice"
                    name="codice"
                    label={translate('Codice') + ':'}
                    //placeholder={translate('Codice')} --> se c'è la prop label non imposto la prop placeholder
                    valoreNoFormik={filtroKpi.codice}
                    onChange={(event) => {
                        updateFiltroKpi('codice', event.target.value);
                    }}
                />
            </div>
            <div className={'col-md-12 pt-1'}>
                <NsField
                    id="descrizione"
                    name="descrizione"
                    label={translate('Descrizione') + ':'}
                    //placeholder={translate('Descrizione')} --> se c'è la prop label non imposto la prop placeholder
                    valoreNoFormik={filtroKpi.descrizione}
                    onChange={(event) => {
                        updateFiltroKpi('descrizione', event.target.value);
                    }}
                />
            </div>
            <div className={'col-md-12 pt-1'}>
                <NsField
                    id="tipo_imp_dati"
                    name="tipo_imp_dati"
                    label={translate('Perimetro') + ':'}
                    //placeholder={translate('Perimetro')} --> se c'è la prop label non imposto la prop placeholder
                    valoreNoFormik={filtroKpi.tipo_imp_dati}
                    onChange={(event) => {
                        updateFiltroKpi('tipo_imp_dati', event.target.value);
                    }}
                />
            </div>
            <div className={'col-md-12 pt-1'}>
                <NsField
                    id="id_stato_kpi"
                    name="id_stato_kpi"
                    label={translate("Stato:")}
                    as={"select"}
                    options={() => {
                        let opts = (statiKpi ? statiKpi.map(o => {
                            return {
                                label: o.descrizione,
                                value: o.id_stato_kpi,
                            };
                        }) : []);
                        return opts;
                    }}
                    onChange={(val) => {
                        updateFiltroKpi('id_stato_kpi', val.code);
                    }}
                    valoreNoFormik={filtroKpi.id_stato_kpi}
                    placeholder={translate("Sel. stato")}
                    valueTemplate={(option, props) => {
                        if (option) {
                            let optFiltrata = statiKpi.filter((opt) => opt.id_stato_kpi == option.code);
                            if (optFiltrata && optFiltrata.length > 0) {
                                return (
                                    <Tag value={optFiltrata[0].descrizione}
                                         className="mr-2"
                                         style={{
                                             backgroundColor: getStrRgba(optFiltrata[0].colore),
                                             color: getTextColorForBackgroundStrRgba(optFiltrata[0].colore),
                                             fontSize: '0.9rem',
                                         }}
                                    />
                                );
                            } else {
                                return <Tag value={option.name} className="mr-2"/>
                            }
                        }
                        return <span>{props.placeholder}</span>;
                    }}
                    itemTemplate={(option) => {
                        if (option) {
                            let optFiltrata = statiKpi.filter((opt) => opt.id_stato_kpi == option.code);
                            if (optFiltrata && optFiltrata.length > 0) {
                                return (
                                    <Tag value={optFiltrata[0].descrizione}
                                         className="mr-2"
                                         style={{
                                             backgroundColor: getStrRgba(optFiltrata[0].colore),
                                             color: getTextColorForBackgroundStrRgba(optFiltrata[0].colore),
                                             fontSize: '0.9rem',
                                         }}
                                    />
                                );
                            } else {
                                return <Tag value={option.name} className="mr-2"/>
                            }
                        }
                    }}
                />
            </div>
            <div className="col-md-12 text-center pt-1">
                <NsButton
                    nome={"cerca"}
                    type={"submit"}
                    label={translate("Cerca")}
                    onClick={onClickCerca}
                />
                <NsButton
                    nome={"clear"}
                    label={translate("Azzera filtri")}
                    onClick={onClickAzzeraFiltri}
                />
            </div>
        </div>
    );
}